import { APP } from 'actions/app';

export default function(state = {}, action) {
  switch (action.type) {
    case APP.INIT_AUTH_INFO:
    case APP.LOGIN:
      return {
        ...state,
        accessToken: action.payload.accessToken,
        currentUserId: action.payload.userId,
        userInfo: action.payload.userInfo
      };
    case APP.LOGOUT:
      return {
        ...state,
        accessToken: null,
        currentUserId: null,
        userInfo: null
      };

    case APP.SET_USER_INFO:
      return {
        ...state,
        userInfo: action.payload.userInfo
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/app.js